import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TaxSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TaxSVG;
